let lastScrollTop = 0;

window.addEventListener("scroll", () => {

    const h1 = document.querySelector('.h1-sticky');
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 100){
        if (st > lastScrollTop){
            h1?.classList.add('h1-sticky--out');
        } else {
            h1?.classList.remove('h1-sticky--out');
        }
    }
    else{
        h1?.classList.remove('h1-sticky--out');
    }
    if (st > 0){
        h1?.classList.add('h1-sticky--fixed');
    }
    else{
        h1?.classList.remove('h1-sticky--fixed');
    }
    lastScrollTop = st <= 0 ? 0 : st;

});

